<template>
  <div :class="message.customer ? 'user' : 'admin'">
    <p v-if="index === 0" class="sender">محتوای تیکت</p>
    <p class="message" :style="{ '--load': load + '%' }">
      {{ message.text || message.file }}
      <inline-svg
        class="download"
        v-if="message.file && (!load || load === 100)"
        @click="download(message.file)"
        :src="require('@/assets/icons/download.svg')"
        width="24"
      />
      <inline-svg
        v-if="load && load < 100"
        :src="require('@/assets/icons/mini-loading.svg')"
        width="24"
      />
    </p>
    <p class="creationDate" v-if="message.createdAtDateTime">
      {{ $G2J(message.createdAtDateTime, "faDateTime") }}
    </p>
  </div>
</template>

<script>
import InlineSvg from "vue-inline-svg";

export default {
  name: "message",
  props: ["message", "index"],
  components: { InlineSvg },
  data() {
    return {
      load: "",
    };
  },
  methods: {
    async download(name) {
      await this.$axios({
        url: "/files/download",
        method: "GET",
        responseType: "blob", // important
        params: {
          fileName: name,
        },
        onDownloadProgress: (progressEvent) => {
          console.log("process =>>", progressEvent);
          this.load = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", name); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.message {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  white-space: pre-wrap;
  background-color: var(--light-grey) !important;
  --load: 0%;
  background-image: linear-gradient(
    90deg,
    var(--grey) var(--dark-grey),
    transparent 0%
  );

  .download {
    cursor: pointer;
  }
}

.user {
  display: flex;
  flex-direction: column;

  p {
    padding: 10px;
    width: 80%;
    background-color: var(--background);
    border-radius: 5px;
    align-self: flex-start;
  }

  .creationDate {
    width: max-content;
    position: absolute;
    left: 21%;
    top: -35px;
    background: #1a202e00;
  }

  .sender {
    position: absolute;
    background-color: #f3f3f300 !important;
    width: max-content;
    top: -35px;
  }
}

.admin {
  display: flex;
  flex-direction: column;

  p {
    width: 80%;
    background-color: #f5921f73;
    border-radius: 5px;
    padding: 10px;
    align-self: flex-end;
  }

  .creationDate {
    width: max-content;
    position: absolute;
    left: 5px;
    top: -35px;
    background: #1a202e00;
  }

  .sender {
    position: absolute;
    background-color: #f3f3f300 !important;
    width: max-content;
    top: -35px;
    right: 20%;
  }
}
</style>
